"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantConfigurationApi = void 0;
var lodash_1 = require("lodash");
var MerchantConfigurationEntity_1 = __importDefault(require("./Entity/MerchantConfigurationEntity"));
var MerchantConfiguration_consts_1 = require("./MerchantConfiguration.consts");
var MerchantConfigurationApi = /** @class */ (function () {
    function MerchantConfigurationApi(session) {
        this.entity = new MerchantConfigurationEntity_1.default(session);
    }
    MerchantConfigurationApi.prototype.get = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.get()];
            });
        });
    };
    MerchantConfigurationApi.prototype.fetchConfiguration = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.fetchConfiguration()];
            });
        });
    };
    MerchantConfigurationApi.prototype.update = function (diff) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.update((0, lodash_1.pick)(diff, MerchantConfiguration_consts_1.MerchantConfigurationKeys))];
            });
        });
    };
    MerchantConfigurationApi.prototype.uploadLogo = function (imageFile) {
        return this.entity.uploadLogo(imageFile);
    };
    MerchantConfigurationApi.prototype.resetDeliveryPin = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.resetDeliveryPin()];
            });
        });
    };
    MerchantConfigurationApi.prototype.resetDestinationPin = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.resetDestinationPin()];
            });
        });
    };
    MerchantConfigurationApi.prototype.getCsvFields = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.getCsvFields()];
            });
        });
    };
    MerchantConfigurationApi.prototype.setCsvFields = function (csvFields) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.setCsvFields(csvFields)];
            });
        });
    };
    MerchantConfigurationApi.prototype.getUserCsvFields = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.getUserCsvFields()];
            });
        });
    };
    MerchantConfigurationApi.prototype.dashboardTableConfigurationUpdate = function (table_configuration) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.dashboardTableConfigurationUpdate(table_configuration)];
            });
        });
    };
    MerchantConfigurationApi.prototype.setDashboardUiConfigurationOnMerchantLevel = function (dashboardUiConfiguration) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.setDashboardUiConfigurationOnMerchantLevel(dashboardUiConfiguration)];
            });
        });
    };
    MerchantConfigurationApi.prototype.setUserCsvFields = function (csvFields) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.setUserCsvFields(csvFields)];
            });
        });
    };
    MerchantConfigurationApi.prototype.deliveryPinChange = function (alternativePin) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.deliveryPinChange(alternativePin)];
            });
        });
    };
    MerchantConfigurationApi.prototype.resetEmailLogo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.resetEmailLogo()];
            });
        });
    };
    MerchantConfigurationApi.prototype.resetClientAppLogo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.resetClientAppLogo()];
            });
        });
    };
    MerchantConfigurationApi.prototype.getRatingReasonConfiguration = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.getRatingReasonConfiguration()];
            });
        });
    };
    MerchantConfigurationApi.prototype.setRatingReasonConfiguration = function (ratingReasonConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.setRatingReasonConfiguration(ratingReasonConfig)];
            });
        });
    };
    MerchantConfigurationApi.prototype.requestBetaProgram = function (featureName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.requestBetaProgram(featureName)];
            });
        });
    };
    MerchantConfigurationApi.prototype.getTipDriverConfiguration = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.getTipDriverConfiguration()];
            });
        });
    };
    MerchantConfigurationApi.prototype.setTipDriverConfiguration = function (configuration) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.setTipDriverConfiguration(configuration)];
            });
        });
    };
    MerchantConfigurationApi.prototype.getMobileTaskForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.getMobileTaskForm()];
            });
        });
    };
    MerchantConfigurationApi.prototype.setMobileTaskForm = function (form) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.entity.setMobileTaskForm(form)];
            });
        });
    };
    return MerchantConfigurationApi;
}());
exports.MerchantConfigurationApi = MerchantConfigurationApi;
//# sourceMappingURL=MerchantConfigurationApi.js.map